<template>
  <div
    class="d-flex flex-column"
  >
    <label
      for="note"
      class="mb-1 note-label"
    >
      Add a note
    </label>
    <v-textarea
      id="note"
      v-model="value"
      variant="outlined"
      bg-color="bgCanvas"
      rounded="lg"
      base-color="grey400"
      color="grey400"
      no-resize
      hide-details
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['update:modelValue']);

const value = computed({
  get() {
    return props.modelValue;
  },
  set(newValue) {
    emit('update:modelValue', newValue);
  },
});
</script>

<style scoped lang="less">
.v-textarea {
  :deep(.v-field__outline) {
    --v-field-border-width: 1px !important;
  }

  :deep(textarea) {
    font-size: 13px;
    font-weight: 500 !important;
    line-height: 150%;
  }
}

.note-label {
  font-size: 12px;
  line-height: 150%;
  font-weight: 500;
  color: @text-darkest;
}
</style>
